


























































import { Component, Vue } from "vue-property-decorator";
import { ProductMarketMatrix, ProductMarketMatrixLevel } from "@/interfaces";

import { getProductsMarketsMatrix } from "@/services";
import { notifyError } from "@/common/notify";

import { reverse, sortBy } from "lodash";

@Component
export default class MarketsSurvey extends Vue {
  matrix: ProductMarketMatrix[] = [];

  loading = false;

  async mounted() {
    try {
      this.matrix = await getProductsMarketsMatrix();
    } catch (error) {
      console.log(error);
      notifyError("Errore durante il reperimento della matrice, riprova più tardi");
    }
  }

  sortByMethod(rows: ProductMarketMatrix[], sortByPar: string, descending: boolean) {
    let sortedRows = [...rows];
    const sortKeys = [];

    switch (sortByPar) {
      case "status":
        sortKeys.push("order");
        break;
      case "prodotto":
        sortKeys.push("prodotto");
        break;
      case "mercato":
        sortKeys.push("mercato");
        break;
    }

    if (sortKeys.length > 0) {
      sortedRows = sortBy(sortedRows, sortKeys);

      if (descending) {
        sortedRows = reverse(sortedRows);
      }
    }

    return sortedRows;
  }

  get statusLabelClass() {
    return (level: ProductMarketMatrixLevel) => {
      switch (level) {
        case ProductMarketMatrixLevel.ELEVATO:
          return "text-positive";
        case ProductMarketMatrixLevel.DISCRETO:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (level: ProductMarketMatrixLevel) => {
      switch (level) {
        case ProductMarketMatrixLevel.ELEVATO:
          return "Elevato";
        case ProductMarketMatrixLevel.DISCRETO:
          return "Discreto";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "prodotto",
        label: "Prodotto",
        field: "prodotto",
        align: "left",
        sortable: true,
      },
      {
        name: "mercato",
        label: "Mercato",
        field: "mercato",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Livello di priorità",
        field: "livello_priorita",
        align: "center",
        sortable: true,
      },
    ];
  }
}
